import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _activity = { createdDate: 'google.protobuf.Timestamp' };
var _addActivityRequest = {};
var _addActivityResponse = { order: '_order' };
var _addInternalActivityRequest = { activity: '_internalActivity' };
var _addInternalActivityResponse = { order: '_order' };
var _aggregateOrdersRequest = {};
var _aggregateOrdersResponse = {};
var _archiveOrderRequest = {};
var _archiveOrderResponse = { order: '_order' };
var _bulkArchiveOrdersByFilterRequest = {};
var _bulkArchiveOrdersByFilterResponse = { results: '_bulkOrderResult' };
var _bulkArchiveOrdersRequest = {};
var _bulkArchiveOrdersResponse = { results: '_bulkOrderResult' };
var _bulkMarkAsFulfilledByFilterRequest = {};
var _bulkMarkAsFulfilledByFilterResponse = { results: '_bulkOrderResult' };
var _bulkMarkAsFulfilledRequest = {};
var _bulkMarkAsFulfilledResponse = { results: '_bulkOrderResult' };
var _bulkMarkAsUnfulfilledByFilterRequest = {};
var _bulkMarkAsUnfulfilledByFilterResponse = { results: '_bulkOrderResult' };
var _bulkMarkAsUnfulfilledRequest = {};
var _bulkMarkAsUnfulfilledResponse = { results: '_bulkOrderResult' };
var _bulkMarkOrdersAsPaidRequest = {};
var _bulkMarkOrdersAsPaidResponse = { results: '_bulkOrderResult' };
var _bulkOrderResult = { item: '_order' };
var _bulkUnArchiveOrdersByFilterRequest = {};
var _bulkUnArchiveOrdersByFilterResponse = { results: '_bulkOrderResult' };
var _bulkUnArchiveOrdersRequest = {};
var _bulkUnArchiveOrdersResponse = { results: '_bulkOrderResult' };
var _calculateRefundRequest = {};
var _calculateRefundResponse = {};
var _cancelOrderRequest = {};
var _cancelOrderResponse = { order: '_order' };
var _chargeMembershipsRequest = {
    membershipCharges: '_membershipChargeItem',
};
var _chargeMembershipsResponse = {};
var _commitDeltasRequest = { changes: '_draftOrderDiffs' };
var _commitDeltasResponse = { order: '_order' };
var _createOrderRequest = { order: '_order' };
var _createOrderResponse = { order: '_order' };
var _createPaymentGatewayOrderRequest = {};
var _createPaymentGatewayOrderResponse = {};
var _decrementItemsQuantityRequest = {};
var _decrementItemsQuantityResponse = { order: '_order' };
var _deleteActivityRequest = {};
var _deleteActivityResponse = { order: '_order' };
var _deliveryLogistics = {
    deliverByDate: 'google.protobuf.Timestamp',
    deliveryTimeSlot: '_deliveryTimeSlot',
};
var _deliveryTimeSlot = {
    from: 'google.protobuf.Timestamp',
    to: 'google.protobuf.Timestamp',
};
var _digitalFile = { expirationDate: 'google.protobuf.Timestamp' };
var _draftOrderDiffs = {
    changedShippingInfo: '_shippingInformation',
    lineItems: '_lineItemDelta',
};
var _getMetasiteDataRequest = {};
var _getMetasiteDataResponse = { metasite: '_metaSite' };
var _getOrderForMetasiteRequest = {};
var _getOrderForMetasiteResponse = { order: '_order' };
var _getOrderRequest = {};
var _getOrderResponse = { order: '_order' };
var _getPaymentCollectabilityStatusRequest = {};
var _getPaymentCollectabilityStatusResponse = {};
var _getRefundabilityStatusRequest = {};
var _getRefundabilityStatusResponse = {};
var _getShipmentsRequest = {};
var _getShipmentsResponse = {};
var _hasOrdersInOldSystemRequest = {};
var _hasOrdersInOldSystemResponse = {};
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _internalActivity = { createdDate: 'google.protobuf.Timestamp' };
var _internalQueryOrdersRequest = {};
var _internalQueryOrdersResponse = { orders: '_order' };
var _lineItemDelta = { lineItem: '_orderLineItemChangedDetails' };
var _listOrdersForMetasiteRequest = {
    listOrderRequest: '_listOrdersRequest',
};
var _listOrdersForMetasiteResponse = { orders: '_order' };
var _listOrdersRequest = {};
var _listOrdersResponse = { orders: '_order' };
var _listOrderTransactionsForMetasiteRequest = {};
var _listOrderTransactionsForMetasiteResponse = {
    orderTransactions: '_orderTransactions',
};
var _markAsFulfilledRequest = {};
var _markAsFulfilledResponse = { order: '_order' };
var _markAsUnfulfilledRequest = {};
var _markAsUnfulfilledResponse = { order: '_order' };
var _markOrderAsPaidRequest = {};
var _markOrderAsPaidResponse = { order: '_order' };
var _markOrderAsSeenByHumanRequest = {};
var _markOrderAsSeenByHumanResponse = { order: '_order' };
var _membershipChargeItem = { serviceProperties: '_serviceProperties' };
var _metaSite = {
    dateCreated: 'google.protobuf.Timestamp',
    dateUpdated: 'google.protobuf.Timestamp',
};
var _order = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    lineItems: '_orderLineItem',
    shippingInfo: '_shippingInformation',
    activities: '_activity',
};
var _orderLineItem = {
    image: '_image',
    physicalProperties: '_physicalProperties',
    digitalFile: '_digitalFile',
};
var _orderLineItemChangedDetails = {
    image: '_image',
    physicalProperties: '_physicalProperties',
    digitalFile: '_digitalFile',
};
var _orderTransactions = { payments: '_v1Payment', refunds: '_refund' };
var _physicalProperties = { weight: 'google.protobuf.DoubleValue' };
var _preparePaymentCollectionRequest = {};
var _preparePaymentCollectionResponse = {};
var _previewBuyerConfirmationEmailRequest = {};
var _previewBuyerConfirmationEmailResponse = {};
var _previewBuyerPaymentsReceivedEmailRequest = {};
var _previewBuyerPaymentsReceivedEmailResponse = {};
var _previewBuyerPickupConfirmationEmailRequest = {};
var _previewBuyerPickupConfirmationEmailResponse = {};
var _previewCancelEmailRequest = {};
var _previewCancelEmailResponse = {};
var _previewCancelRefundEmailRequest = {};
var _previewCancelRefundEmailResponse = {};
var _previewEmailByTypeRequest = {};
var _previewEmailByTypeResponse = {};
var _previewRefundEmailRequest = {};
var _previewRefundEmailResponse = {};
var _previewResendDownloadLinksEmailRequest = {};
var _previewResendDownloadLinksEmailResponse = {};
var _previewShippingConfirmationEmailRequest = {};
var _previewShippingConfirmationEmailResponse = {};
var _queryOrderRequest = {};
var _queryOrderResponse = { orders: '_order' };
var _queryOrdersForMetasiteRequest = {
    internalQueryOrdersRequest: '_internalQueryOrdersRequest',
};
var _queryOrdersForMetasiteResponse = { orders: '_order' };
var _recordManuallyCollectedPaymentRequest = {};
var _recordManuallyCollectedPaymentResponse = {};
var _refund = { createdDate: 'google.protobuf.Timestamp' };
var _sendBuyerConfirmationEmailRequest = {};
var _sendBuyerConfirmationEmailResponse = {};
var _sendBuyerPaymentsReceivedEmailRequest = {};
var _sendBuyerPaymentsReceivedEmailResponse = {};
var _sendBuyerPickupConfirmationEmailRequest = {};
var _sendBuyerPickupConfirmationEmailResponse = {};
var _sendBuyerShippingConfirmationEmailRequest = {};
var _sendBuyerShippingConfirmationEmailResponse = {};
var _sendCancelRefundEmailRequest = {};
var _sendCancelRefundEmailResponse = {};
var _sendMerchantOrderReceivedNotificationRequest = {};
var _sendMerchantOrderReceivedNotificationResponse = {};
var _sendMerchantOrderReceivedPushRequest = {};
var _sendMerchantOrderReceivedPushResponse = {};
var _serviceProperties = { scheduledDate: 'google.protobuf.Timestamp' };
var _shippingInformation = { logistics: '_deliveryLogistics' };
var _triggerRefundRequest = {};
var _triggerRefundResponse = { orderTransactions: '_orderTransactions' };
var _triggerReindexRequest = {};
var _triggerReindexResponse = {};
var _unArchiveOrderRequest = {};
var _unArchiveOrderResponse = { order: '_order' };
var _updateActivityRequest = {};
var _updateActivityResponse = { order: '_order' };
var _updateBillingContactDetailsRequest = {
    fieldMask: 'google.protobuf.FieldMask',
};
var _updateBillingContactDetailsResponse = { order: '_order' };
var _updateBuyerInfoRequest = { fieldMask: 'google.protobuf.FieldMask' };
var _updateBuyerInfoResponse = { order: '_order' };
var _updateLineItemsDescriptionLinesRequest = {};
var _updateLineItemsDescriptionLinesResponse = { order: '_order' };
var _updateOrderLineItemRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    lineItem: '_orderLineItem',
};
var _updateOrderLineItemResponse = { order: '_order' };
var _updateOrderRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    order: '_order',
};
var _updateOrderResponse = { order: '_order' };
var _updateOrderShippingAddressRequest = {
    fieldMask: 'google.protobuf.FieldMask',
};
var _updateOrderShippingAddressResponse = { order: '_order' };
var _v1BulkMarkOrdersAsPaidRequest = {};
var _v1BulkMarkOrdersAsPaidResponse = { results: '_bulkOrderResult' };
var _v1CreatePaymentGatewayOrderRequest = {};
var _v1CreatePaymentGatewayOrderResponse = {};
var _v1MarkOrderAsPaidRequest = {};
var _v1MarkOrderAsPaidResponse = { order: '_order' };
var _v1Payment = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
function resolveComWixEcomOrdersV1OrdersUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/ecom-orders',
                destPath: '',
            },
            {
                srcPath: '/_api/orders',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/ecom-orders',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/ecom/v1/bulk/orders',
                destPath: '/v1/bulk/orders',
            },
            {
                srcPath: '/ecom/v1/orders',
                destPath: '/v1/orders',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/payments-collector',
                destPath: '/api',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/payments-collector',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/ecom/v1/payments-collector',
                destPath: '/v1/payments-collector',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/ecom/v1/orders/notifications',
                destPath: '/v1/orders/notifications',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/order-notifications',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/order-notifications',
                destPath: '',
            },
            {
                srcPath: '/ecom/v1/orders/notifications',
                destPath: '/v1/orders/notifications',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixEcomOrdersIndexerV1EpOrdersIndexerUrl(opts) {
    var domainToMappings = {};
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixEcomOrdersBackofficeV1EpOrdersBackofficeUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/wix-ecom-ep-backoffice',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/wix-ecom-ep-backoffice',
                destPath: '/api',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/wix-ecom-ep-backoffice',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixEcomOrdersRolloutManagerV1EpOrdersRolloutManagerUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/ep-orders-rollout-manager',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/ep-orders-rollout-manager',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Uses explicitly provided metasite ID to query legacy v1 Orders service
 * and verify if any amount of ecom orders are present in an old (event-source based) system.
 */
export function hasOrdersInOldSystem(payload) {
    var _a = serializer(_hasOrdersInOldSystemRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_hasOrdersInOldSystemResponse, {}).fromJSON;
    function __hasOrdersInOldSystem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'GET',
            methodFqn: 'com.wix.ecom.orders.rollout_manager.v1.EpOrdersRolloutManager.HasOrdersInOldSystem',
            url: resolveComWixEcomOrdersRolloutManagerV1EpOrdersRolloutManagerUrl({
                protoPath: '/v1/has-orders-in-old-system/{metasiteId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __hasOrdersInOldSystem.fromReq = fromReq;
    return __hasOrdersInOldSystem;
}
/**
 * Retrieves metadata for given metasiteID using metasiteReadApi get RPC call
 * Target msid must be provided
 */
export function getMetasiteData(payload) {
    var _a = serializer(_getMetasiteDataRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMetasiteDataResponse, {
        _metaSite: _metaSite,
    }).fromJSON;
    function __getMetasiteData(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'GET',
            methodFqn: 'wix.ecom.orders.backoffice.v1.EpOrdersBackoffice.GetMetasiteData',
            url: resolveWixEcomOrdersBackofficeV1EpOrdersBackofficeUrl({
                protoPath: '/v1/get-metasite-data/{metasiteId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMetasiteData.fromReq = fromReq;
    return __getMetasiteData;
}
/**
 * Retrieves orders for given metasiteID using ep-orders listOrders RPC call
 * Target msid must be provided
 * TODO: deprecated, remove me!
 */
export function listOrdersForMetasite(payload) {
    var _a = serializer(_listOrdersForMetasiteRequest, { _listOrdersRequest: _listOrdersRequest }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listOrdersForMetasiteResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __listOrdersForMetasite(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'wix.ecom.orders.backoffice.v1.EpOrdersBackoffice.ListOrdersForMetasite',
            url: resolveWixEcomOrdersBackofficeV1EpOrdersBackofficeUrl({
                protoPath: '/v1/list-orders-for-metasite',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listOrdersForMetasite.fromReq = fromReq;
    return __listOrdersForMetasite;
}
/**
 * Retrieves orders for given metasiteID using ep-orders internalQueryOrders RPC call
 * Target msid must be provided
 */
export function queryOrdersForMetasite(payload) {
    var _a = serializer(_queryOrdersForMetasiteRequest, { _internalQueryOrdersRequest: _internalQueryOrdersRequest }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryOrdersForMetasiteResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __queryOrdersForMetasite(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'wix.ecom.orders.backoffice.v1.EpOrdersBackoffice.QueryOrdersForMetasite',
            url: resolveWixEcomOrdersBackofficeV1EpOrdersBackofficeUrl({
                protoPath: '/v1/query-orders-for-metasite',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryOrdersForMetasite.fromReq = fromReq;
    return __queryOrdersForMetasite;
}
/**
 * Retrieves order for given metasiteId and orderId using ep-orders getOrder RPC call
 * Target msid and orderId must be provided
 */
export function getOrderForMetasite(payload) {
    var _a = serializer(_getOrderForMetasiteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getOrderForMetasiteResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __getOrderForMetasite(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'GET',
            methodFqn: 'wix.ecom.orders.backoffice.v1.EpOrdersBackoffice.GetOrderForMetasite',
            url: resolveWixEcomOrdersBackofficeV1EpOrdersBackofficeUrl({
                protoPath: '/v1/get-order-for-metasite/{metasiteId}/{orderId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getOrderForMetasite.fromReq = fromReq;
    return __getOrderForMetasite;
}
/**
 * Retrieves order transactions for given metasiteId and orderId using ep-payments listTransactionsForSingleOrder RPC call
 * Target msid and orderId must be provided
 */
export function listOrderTransactionsForMetasite(payload) {
    var _a = serializer(_listOrderTransactionsForMetasiteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listOrderTransactionsForMetasiteResponse, { _orderTransactions: _orderTransactions, _refund: _refund, _v1Payment: _v1Payment }).fromJSON;
    function __listOrderTransactionsForMetasite(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'GET',
            methodFqn: 'wix.ecom.orders.backoffice.v1.EpOrdersBackoffice.ListOrderTransactionsForMetasite',
            url: resolveWixEcomOrdersBackofficeV1EpOrdersBackofficeUrl({
                protoPath: '/v1/list-order-transactions-for-metasite/{metasiteId}/{orderId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listOrderTransactionsForMetasite.fromReq = fromReq;
    return __listOrderTransactionsForMetasite;
}
export function triggerReindex(payload) {
    var _a = serializer(_triggerReindexRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_triggerReindexResponse, {}).fromJSON;
    function __triggerReindex(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.indexer.v1.EpOrdersIndexer.TriggerReindex',
            url: resolveComWixEcomOrdersIndexerV1EpOrdersIndexerUrl({
                protoPath: '/v1/orders-indexer/{metasiteId}/reindex',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __triggerReindex.fromReq = fromReq;
    return __triggerReindex;
}
export function sendBuyerConfirmationEmail(payload) {
    var _a = serializer(_sendBuyerConfirmationEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_sendBuyerConfirmationEmailResponse, {}).fromJSON;
    function __sendBuyerConfirmationEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.SendBuyerConfirmationEmail',
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/send-buyer-confirmation-email/{orderId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sendBuyerConfirmationEmail.fromReq = fromReq;
    return __sendBuyerConfirmationEmail;
}
export function sendBuyerPaymentsReceivedEmail(payload) {
    var _a = serializer(_sendBuyerPaymentsReceivedEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_sendBuyerPaymentsReceivedEmailResponse, {}).fromJSON;
    function __sendBuyerPaymentsReceivedEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.SendBuyerPaymentsReceivedEmail',
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/send-buyer-payments-received-email/{orderId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sendBuyerPaymentsReceivedEmail.fromReq = fromReq;
    return __sendBuyerPaymentsReceivedEmail;
}
export function sendBuyerPickupConfirmationEmail(payload) {
    var _a = serializer(_sendBuyerPickupConfirmationEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_sendBuyerPickupConfirmationEmailResponse, {}).fromJSON;
    function __sendBuyerPickupConfirmationEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.SendBuyerPickupConfirmationEmail',
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/send-buyer-pickup-confirmation-email/{orderId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sendBuyerPickupConfirmationEmail.fromReq = fromReq;
    return __sendBuyerPickupConfirmationEmail;
}
export function sendBuyerShippingConfirmationEmail(payload) {
    var _a = serializer(_sendBuyerShippingConfirmationEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_sendBuyerShippingConfirmationEmailResponse, {}).fromJSON;
    function __sendBuyerShippingConfirmationEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.SendBuyerShippingConfirmationEmail',
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/send-buyer-shipping-confirmation-mail/{orderId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sendBuyerShippingConfirmationEmail.fromReq = fromReq;
    return __sendBuyerShippingConfirmationEmail;
}
/** this will send notification to merchant via both email and via Notification Hub */
export function sendMerchantOrderReceivedNotification(payload) {
    var _a = serializer(_sendMerchantOrderReceivedNotificationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_sendMerchantOrderReceivedNotificationResponse, {}).fromJSON;
    function __sendMerchantOrderReceivedNotification(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.SendMerchantOrderReceivedNotification',
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/send-merchant-order-received-notification/{orderId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sendMerchantOrderReceivedNotification.fromReq = fromReq;
    return __sendMerchantOrderReceivedNotification;
}
export function sendCancelRefundEmail(payload) {
    var _a = serializer(_sendCancelRefundEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_sendCancelRefundEmailResponse, {}).fromJSON;
    function __sendCancelRefundEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.SendCancelRefundEmail',
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/send-cancel-refund-email/{orderId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sendCancelRefundEmail.fromReq = fromReq;
    return __sendCancelRefundEmail;
}
export function sendMerchantOrderReceivedPush(payload) {
    var _a = serializer(_sendMerchantOrderReceivedPushRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_sendMerchantOrderReceivedPushResponse, {}).fromJSON;
    function __sendMerchantOrderReceivedPush(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.SendMerchantOrderReceivedPush',
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/send-merchant-order-received-push/{orderId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sendMerchantOrderReceivedPush.fromReq = fromReq;
    return __sendMerchantOrderReceivedPush;
}
export function previewEmailByType(payload) {
    var _a = serializer(_previewEmailByTypeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_previewEmailByTypeResponse, {}).fromJSON;
    function __previewEmailByType(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'GET',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.PreviewEmailByType',
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/preview/{emailType}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __previewEmailByType.fromReq = fromReq;
    return __previewEmailByType;
}
export function previewRefundEmail(payload) {
    var _a = serializer(_previewRefundEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_previewRefundEmailResponse, {}).fromJSON;
    function __previewRefundEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.PreviewRefundEmail',
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/preview/refund',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __previewRefundEmail.fromReq = fromReq;
    return __previewRefundEmail;
}
export function previewCancelEmail(payload) {
    var _a = serializer(_previewCancelEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_previewCancelEmailResponse, {}).fromJSON;
    function __previewCancelEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.PreviewCancelEmail',
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/preview/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __previewCancelEmail.fromReq = fromReq;
    return __previewCancelEmail;
}
export function previewCancelRefundEmail(payload) {
    var _a = serializer(_previewCancelRefundEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_previewCancelRefundEmailResponse, {}).fromJSON;
    function __previewCancelRefundEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.PreviewCancelRefundEmail',
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/preview/cancel-refund',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __previewCancelRefundEmail.fromReq = fromReq;
    return __previewCancelRefundEmail;
}
export function previewBuyerPaymentsReceivedEmail(payload) {
    var _a = serializer(_previewBuyerPaymentsReceivedEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_previewBuyerPaymentsReceivedEmailResponse, {}).fromJSON;
    function __previewBuyerPaymentsReceivedEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.PreviewBuyerPaymentsReceivedEmail',
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/preview/buyer-payments-received',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __previewBuyerPaymentsReceivedEmail.fromReq = fromReq;
    return __previewBuyerPaymentsReceivedEmail;
}
/** Deprecated, use PreviewEmailByType with ORDER_PLACED type instead */
export function previewBuyerConfirmationEmail(payload) {
    var _a = serializer(_previewBuyerConfirmationEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_previewBuyerConfirmationEmailResponse, {}).fromJSON;
    function __previewBuyerConfirmationEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.PreviewBuyerConfirmationEmail',
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/preview/buyer-confirmation',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __previewBuyerConfirmationEmail.fromReq = fromReq;
    return __previewBuyerConfirmationEmail;
}
/** Deprecated, use PreviewEmailByType with ORDER_READY_FOR_PICKUP type instead */
export function previewBuyerPickupConfirmationEmail(payload) {
    var _a = serializer(_previewBuyerPickupConfirmationEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_previewBuyerPickupConfirmationEmailResponse, {}).fromJSON;
    function __previewBuyerPickupConfirmationEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.PreviewBuyerPickupConfirmationEmail',
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/preview/buyer-pickup-confirmation',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __previewBuyerPickupConfirmationEmail.fromReq = fromReq;
    return __previewBuyerPickupConfirmationEmail;
}
/** Deprecated, use PreviewEmailByType with ORDER_SHIPPED type instead */
export function previewShippingConfirmationEmail(payload) {
    var _a = serializer(_previewShippingConfirmationEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_previewShippingConfirmationEmailResponse, {}).fromJSON;
    function __previewShippingConfirmationEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.PreviewShippingConfirmationEmail',
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/preview/shipping-confirmation',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __previewShippingConfirmationEmail.fromReq = fromReq;
    return __previewShippingConfirmationEmail;
}
/** Deprecated, use PreviewEmailByType with DOWNLOAD_LINKS type instead */
export function previewResendDownloadLinksEmail(payload) {
    var _a = serializer(_previewResendDownloadLinksEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_previewResendDownloadLinksEmailResponse, {}).fromJSON;
    function __previewResendDownloadLinksEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.notifications.v1.OrderNotifications.PreviewResendDownloadLinksEmail',
            url: resolveComWixEcomOrdersNotificationsV1OrderNotificationsUrl({
                protoPath: '/v1/orders/notifications/preview/resend-download-link',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __previewResendDownloadLinksEmail.fromReq = fromReq;
    return __previewResendDownloadLinksEmail;
}
/**
 * Prepares payment collection for given ecom order. This is the first of 2-step process of payment collection.
 * Here we ensure that payment collection is possible for given order and store and prepare payment gateway order for future charge.
 * 2nd step is an actual charge of prepared payment gateway order. This could be done either
 * via Wix-Cashier's API (https://bo.wix.com/wix-docs/rest/wix-cashier/pay/charge/charge-for-order)
 * or using Cashier Payments Widget (https://github.com/wix-private/cashier-client/tree/master/packages/cashier-payments-widget)
 */
export function preparePaymentCollection(payload) {
    var _a = serializer(_preparePaymentCollectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_preparePaymentCollectionResponse, {}).fromJSON;
    function __preparePaymentCollection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.payments_collector.v1.PaymentsCollector.PreparePaymentCollection',
            url: resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl({
                protoPath: '/v1/payments-collector/orders/{ecomOrderId}/prepare-payment-collection',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __preparePaymentCollection.fromReq = fromReq;
    return __preparePaymentCollection;
}
/**
 * Provides payment collectability status for given order. If payment collection is possible
 * response will contain collectable amount for given ecom order. If not - response will contain
 * reason why payment collection is not possible.
 */
export function getPaymentCollectabilityStatus(payload) {
    var _a = serializer(_getPaymentCollectabilityStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPaymentCollectabilityStatusResponse, {}).fromJSON;
    function __getPaymentCollectabilityStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'GET',
            methodFqn: 'com.wix.ecom.orders.payments_collector.v1.PaymentsCollector.GetPaymentCollectabilityStatus',
            url: resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl({
                protoPath: '/v1/payments-collector/orders/{ecomOrderId}/payment-collectability-status',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPaymentCollectabilityStatus.fromReq = fromReq;
    return __getPaymentCollectabilityStatus;
}
/**
 * Records and approves new manual payment with provided custom amount on given order.
 * Existing pending payments are ignored.
 * Custom amount is expected to be less or equal remaining amount to be paid on order (affected by approved payments, refunds and gift card payments)
 */
export function recordManuallyCollectedPayment(payload) {
    var _a = serializer(_recordManuallyCollectedPaymentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_recordManuallyCollectedPaymentResponse, {}).fromJSON;
    function __recordManuallyCollectedPayment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.payments_collector.v1.PaymentsCollector.RecordManuallyCollectedPayment',
            url: resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl({
                protoPath: '/v1/payments-collector/orders/{orderId}/manual-payment',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __recordManuallyCollectedPayment.fromReq = fromReq;
    return __recordManuallyCollectedPayment;
}
/**
 * Marks the order as paid. `order.paymentStatus` field *eventually* changes to `PAID`.
 * In case the order already has an offline payment transaction associated with it
 * (usually when manual payment method is chosen at checkout) - This transaction will become approved.
 * In case the order has no payment transactions associated with it
 * (usually when the item is set to be paid offline after checkout or when an order is created from the backoffice) - A payment transaction
 * will be created and approved.
 */
export function paymentCollectionMarkOrderAsPaid(payload) {
    var _a = serializer(_v1MarkOrderAsPaidRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v1MarkOrderAsPaidResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __paymentCollectionMarkOrderAsPaid(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.payments_collector.v1.PaymentsCollector.MarkOrderAsPaid',
            url: resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl({
                protoPath: '/v1/payments-collector/orders/{ecomOrderId}/mark-as-paid',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __paymentCollectionMarkOrderAsPaid.fromReq = fromReq;
    return __paymentCollectionMarkOrderAsPaid;
}
/** Marks multiple orders as paid. `order.paymentStatus` field *eventually* changes to `PAID`. */
export function paymentCollectionBulkMarkOrdersAsPaid(payload) {
    var _a = serializer(_v1BulkMarkOrdersAsPaidRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v1BulkMarkOrdersAsPaidResponse, {
        _activity: _activity,
        _bulkOrderResult: _bulkOrderResult,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __paymentCollectionBulkMarkOrdersAsPaid(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.payments_collector.v1.PaymentsCollector.BulkMarkOrdersAsPaid',
            url: resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl({
                protoPath: '/v1/bulk/payments-collector/mark-as-paid',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __paymentCollectionBulkMarkOrdersAsPaid.fromReq = fromReq;
    return __paymentCollectionBulkMarkOrdersAsPaid;
}
/** Checks whether this order can be refunded. */
export function getRefundabilityStatus(payload) {
    var _a = serializer(_getRefundabilityStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getRefundabilityStatusResponse, {}).fromJSON;
    function __getRefundabilityStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'GET',
            methodFqn: 'com.wix.ecom.orders.payments_collector.v1.PaymentsCollector.GetRefundabilityStatus',
            url: resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl({
                protoPath: '/v1/payments-collector/orders/{ecomOrderId}/refundability',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getRefundabilityStatus.fromReq = fromReq;
    return __getRefundabilityStatus;
}
/**
 * Call this endpoint to create an order in the payment gateway system. The amount of the order would be either:
 * 1. An explicit amount provided in the request, or;
 * 2. If an explicit amount is not provided - the remaining amount to complete the payment of that eCom order.
 * As a result, an ID of the created payment gateway order would be returned.
 * You can then use Wix Payments APIs to approve that order or collect payment, which will eventually change the eCom order state (e.g mark it as paid).
 */
export function paymentCollectionCreatePaymentGatewayOrder(payload) {
    var _a = serializer(_v1CreatePaymentGatewayOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v1CreatePaymentGatewayOrderResponse, {}).fromJSON;
    function __paymentCollectionCreatePaymentGatewayOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.payments_collector.v1.PaymentsCollector.CreatePaymentGatewayOrder',
            url: resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl({
                protoPath: '/v1/payments-collector/orders/{ecomOrderId}/create-payment-gateway-order',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __paymentCollectionCreatePaymentGatewayOrder.fromReq = fromReq;
    return __paymentCollectionCreatePaymentGatewayOrder;
}
export function chargeMemberships(payload) {
    var _a = serializer(_chargeMembershipsRequest, { _membershipChargeItem: _membershipChargeItem, _serviceProperties: _serviceProperties }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_chargeMembershipsResponse, {}).fromJSON;
    function __chargeMemberships(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.payments_collector.v1.PaymentsCollector.ChargeMemberships',
            url: resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl({
                protoPath: '/v1/payments-collector/orders/{ecomOrderId}/charge-membership',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __chargeMemberships.fromReq = fromReq;
    return __chargeMemberships;
}
/**
 * Calls corresponding payment providers and creates refund transactions for requested payments.
 * Updates order transactions based on refund results.
 * For requested payments with `TriggerRefundRequest.payments.external_refund = true` will not call payment providers and
 * will only update order transactions.
 */
export function triggerRefund(payload) {
    var _a = serializer(_triggerRefundRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_triggerRefundResponse, {
        _orderTransactions: _orderTransactions,
        _refund: _refund,
        _v1Payment: _v1Payment,
    }).fromJSON;
    function __triggerRefund(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.payments_collector.v1.PaymentsCollector.TriggerRefund',
            url: resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl({
                protoPath: '/v1/payments-collector/orders/{ecomOrderId}/trigger-refund',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __triggerRefund.fromReq = fromReq;
    return __triggerRefund;
}
/** Calculates refundable amount for order items specified in request. */
export function calculateRefund(payload) {
    var _a = serializer(_calculateRefundRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_calculateRefundResponse, {}).fromJSON;
    function __calculateRefund(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.payments_collector.v1.PaymentsCollector.CalculateRefund',
            url: resolveComWixEcomOrdersPaymentsCollectorV1PaymentsCollectorUrl({
                protoPath: '/v1/payments-collector/orders/{ecomOrderId}/calculate-refund',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __calculateRefund.fromReq = fromReq;
    return __calculateRefund;
}
/** Retrieves an order with the provided ID. */
export function getOrder(payload) {
    var _a = serializer(_getOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getOrderResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __getOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'GET',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.GetOrder',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getOrder.fromReq = fromReq;
    return __getOrder;
}
/**
 * Retrieves orders for store sorted by createdDate ASC.
 * If ListOrdersRequest.ids is empty will return list of all orders
 * else will be filtered by ids
 */
export function listOrders(payload) {
    var _a = serializer(_listOrdersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listOrdersResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __listOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'GET',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.ListOrders',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listOrders.fromReq = fromReq;
    return __listOrders;
}
/**
 * <!--ONLY:REST-->
 * Internal query orders endpoint without additional logic to hide INIT orders.
 * Returns a list of up to 100 orders, given the provided paging, filtering and sorting.
 *
 * To learn how to query orders, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
 * <!--END:ONLY:REST-->
 */
export function internalQueryOrders(payload) {
    var _a = serializer(_internalQueryOrdersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_internalQueryOrdersResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __internalQueryOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.InternalQueryOrders',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/internal/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __internalQueryOrders.fromReq = fromReq;
    return __internalQueryOrders;
}
/**
 * <!--ONLY:REST-->
 * Returns a list of up to 300 orders, given the provided paging, filtering and sorting.
 *
 * To learn how to query orders, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
 * For a detailed list of supported filters and sorting options,
 * see [Field Support for Filtering and Sorting](https://bo.wix.com/wix-docs/rest/ecommerce/orders/filter-and-sort#ecommerce_orders_filter-and-sort_field-support-for-filtering-and-sorting).
 * <!--END:ONLY:REST-->
 */
export function queryOrders(payload) {
    var _a = serializer(_queryOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryOrderResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __queryOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.QueryOrders',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryOrders.fromReq = fromReq;
    return __queryOrders;
}
/**
 * Creates a new order.
 *
 * Some fields are marked as required. Note these further requirements:
 *
 * The `order.shippingInfo.logistics.shippingDestination.address` field must be provided, **unless**:
 * + The order is for pickup - `order.shippingInfo.logistics.pickupDetails.address` is defined
 * + There are no shippable items in the order - `order.lineItems[n].physicalProperties.shippable` boolean is `false`
 * + This is a POS (point of sale) order - `order.channelInfo.type` value is `POS`
 *
 * The `order.billingInfo.address` field must be provided **unless**:
 * + There are no shippable items in the order - `order.lineItems[n].physicalProperties.shippable` boolean is `false`
 * + This is a POS (point of sale) order - `order.channelInfo.type` value is `POS`
 *
 * When catalog items are added - `order.lineItems.catalogReference` is defined - the following rules apply:
 * + When providing description lines - `order.lineItem.descriptionLines.plainText/colorInfo` must have value
 * + If the product is digital ( `order.lineItems.itemType.preset: DIGITAL` ), then `order.lineItem.digitalFile` must be provided
 *
 * When custom line items are added - `order.lineItems.catalogReference` is **not** defined - the following rules apply:
 * + `order.lineItem.physicalProperties` cannot be set
 * + `order.lineItem.fulfillerId` cannot be set
 * + `order.lineItem.totalDiscount` cannot be set
 * + Applied discounts cannot be set for a custom line item - `order.appliedDiscounts.lineItemIds` cannot contain the custom line item ID.
 */
export function createOrder(payload) {
    var _a = serializer(_createOrderRequest, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createOrderResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __createOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.CreateOrder',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createOrder.fromReq = fromReq;
    return __createOrder;
}
export function updateOrder(payload) {
    var _a = serializer(_updateOrderRequest, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateOrderResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __updateOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'PATCH',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.UpdateOrder',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{order.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateOrder.fromReq = fromReq;
    return __updateOrder;
}
export function commitDeltas(payload) {
    var _a = serializer(_commitDeltasRequest, {
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _draftOrderDiffs: _draftOrderDiffs,
        _image: _image,
        _lineItemDelta: _lineItemDelta,
        _orderLineItemChangedDetails: _orderLineItemChangedDetails,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_commitDeltasResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __commitDeltas(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.CommitDeltas',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/commit-deltas',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __commitDeltas.fromReq = fromReq;
    return __commitDeltas;
}
/** Archives an order. `order.archived` field changes to `true`. */
export function archiveOrder(payload) {
    var _a = serializer(_archiveOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_archiveOrderResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __archiveOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.ArchiveOrder',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/archive',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __archiveOrder.fromReq = fromReq;
    return __archiveOrder;
}
/** Archives multiple orders. `order.archived` field changes to `true`. */
export function bulkArchiveOrders(payload) {
    var _a = serializer(_bulkArchiveOrdersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkArchiveOrdersResponse, {
        _activity: _activity,
        _bulkOrderResult: _bulkOrderResult,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __bulkArchiveOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.BulkArchiveOrders',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/bulk/orders/archive',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkArchiveOrders.fromReq = fromReq;
    return __bulkArchiveOrders;
}
/** Archives multiple orders, selected by filter. `order.archived` field changes to `true`. */
export function bulkArchiveOrdersByFilter(payload) {
    var _a = serializer(_bulkArchiveOrdersByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkArchiveOrdersByFilterResponse, {
        _activity: _activity,
        _bulkOrderResult: _bulkOrderResult,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __bulkArchiveOrdersByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.BulkArchiveOrdersByFilter',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/bulk/orders/archive-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkArchiveOrdersByFilter.fromReq = fromReq;
    return __bulkArchiveOrdersByFilter;
}
/** Unarchives an order. `order.archived` field changes to `false`. */
export function unArchiveOrder(payload) {
    var _a = serializer(_unArchiveOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_unArchiveOrderResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __unArchiveOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.UnArchiveOrder',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/unarchive',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __unArchiveOrder.fromReq = fromReq;
    return __unArchiveOrder;
}
/** Unarchives multiple orders. `order.archived` field changes to `false`. */
export function bulkUnArchiveOrders(payload) {
    var _a = serializer(_bulkUnArchiveOrdersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUnArchiveOrdersResponse, {
        _activity: _activity,
        _bulkOrderResult: _bulkOrderResult,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __bulkUnArchiveOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.BulkUnArchiveOrders',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/bulk/orders/unarchive',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUnArchiveOrders.fromReq = fromReq;
    return __bulkUnArchiveOrders;
}
/** Unarchives multiple orders, selected by filter. `order.archived` field changes to `false`. */
export function bulkUnArchiveOrdersByFilter(payload) {
    var _a = serializer(_bulkUnArchiveOrdersByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUnArchiveOrdersByFilterResponse, {
        _activity: _activity,
        _bulkOrderResult: _bulkOrderResult,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __bulkUnArchiveOrdersByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.BulkUnArchiveOrdersByFilter',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/bulk/orders/unarchive-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUnArchiveOrdersByFilter.fromReq = fromReq;
    return __bulkUnArchiveOrdersByFilter;
}
/**
 * Updates an order's contact ID and/or email.
 * > **Note:** Neither `email`, nor `contactId` can be removed, only updated.
 */
export function updateBuyerInfo(payload) {
    var _a = serializer(_updateBuyerInfoRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateBuyerInfoResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __updateBuyerInfo(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'PATCH',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.UpdateBuyerInfo',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/update-buyer-info',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateBuyerInfo.fromReq = fromReq;
    return __updateBuyerInfo;
}
/**
 * Updates an order's shipping address and/or contact details.
 * > **Notes:**
 * > + Original order must have existing address to update - `order.shippingInfo.logistics.shippingDestination.address` must have existing value.
 * > + Neither `address`, nor `contactDetails` can be removed, only updated.
 */
export function updateOrderShippingAddress(payload) {
    var _a = serializer(_updateOrderShippingAddressRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateOrderShippingAddressResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __updateOrderShippingAddress(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'PUT',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.UpdateOrderShippingAddress',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/update-shipping-address',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateOrderShippingAddress.fromReq = fromReq;
    return __updateOrderShippingAddress;
}
/** Updates an order's billing contact details. */
export function updateBillingContactDetails(payload) {
    var _a = serializer(_updateBillingContactDetailsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateBillingContactDetailsResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __updateBillingContactDetails(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'PUT',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.UpdateBillingContactDetails',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/update-billing-contact-details',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateBillingContactDetails.fromReq = fromReq;
    return __updateBillingContactDetails;
}
export function updateOrderLineItem(payload) {
    var _a = serializer(_updateOrderLineItemRequest, { _digitalFile: _digitalFile, _image: _image, _orderLineItem: _orderLineItem, _physicalProperties: _physicalProperties }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateOrderLineItemResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __updateOrderLineItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'PATCH',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.UpdateOrderLineItem',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/line-item/{lineItem.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateOrderLineItem.fromReq = fromReq;
    return __updateOrderLineItem;
}
export function addInternalActivity(payload) {
    var _a = serializer(_addInternalActivityRequest, { _internalActivity: _internalActivity }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addInternalActivityResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __addInternalActivity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.AddInternalActivity',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/add-internal-activity',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addInternalActivity.fromReq = fromReq;
    return __addInternalActivity;
}
/**
 * Add's a custom activity or a merchant comment to an order.
 *
 * Examples of custom activities:
 * + Platform - notifications, payments
 * + Stores - digital link sent, pickup read, tracking link updated
 * + Bookings - checked-in, no-show, rescheduled, cancellation mail sent, reminders sent
 * + Events - attendee check-in, reminder mail sent, Zoom link set
 */
export function addActivity(payload) {
    var _a = serializer(_addActivityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addActivityResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __addActivity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.AddActivity',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/activities',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addActivity.fromReq = fromReq;
    return __addActivity;
}
/** Updates an order's activity. */
export function updateActivity(payload) {
    var _a = serializer(_updateActivityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateActivityResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __updateActivity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'PATCH',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.UpdateActivity',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/activities/{activityId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateActivity.fromReq = fromReq;
    return __updateActivity;
}
/**
 * Delete's an order's activity.
 *
 * Only custom activities and merchant comments can be deleted.
 */
export function deleteActivity(payload) {
    var _a = serializer(_deleteActivityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteActivityResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __deleteActivity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'DELETE',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.DeleteActivity',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/activities/{activityId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteActivity.fromReq = fromReq;
    return __deleteActivity;
}
/** Updates an order's line item descriptions. */
export function updateLineItemsDescriptionLines(payload) {
    var _a = serializer(_updateLineItemsDescriptionLinesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateLineItemsDescriptionLinesResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __updateLineItemsDescriptionLines(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.UpdateLineItemsDescriptionLines',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/update-line-items-description-lines',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateLineItemsDescriptionLines.fromReq = fromReq;
    return __updateLineItemsDescriptionLines;
}
/** Marks an order as read in the dashboard. `order.seenByAHuman` field changes to `true`. */
export function markOrderAsSeenByHuman(payload) {
    var _a = serializer(_markOrderAsSeenByHumanRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markOrderAsSeenByHumanResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __markOrderAsSeenByHuman(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.MarkOrderAsSeenByHuman',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/mark-as-seen-by-a-human',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markOrderAsSeenByHuman.fromReq = fromReq;
    return __markOrderAsSeenByHuman;
}
/** Cancels an order. `order.status` field changes to `CANCELED`. */
export function cancelOrder(payload) {
    var _a = serializer(_cancelOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelOrderResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __cancelOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.CancelOrder',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelOrder.fromReq = fromReq;
    return __cancelOrder;
}
/** Marks an order as fulfilled. `order.fulfillmentStatus` field changes to `FULFILLED`. */
export function markAsFulfilled(payload) {
    var _a = serializer(_markAsFulfilledRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markAsFulfilledResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __markAsFulfilled(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.MarkAsFulfilled',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/mark-as-fulfilled',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markAsFulfilled.fromReq = fromReq;
    return __markAsFulfilled;
}
/** Marks multiple orders as fulfilled. `order.fulfillmentStatus` field changes to `FULFILLED`. */
export function bulkMarkAsFulfilled(payload) {
    var _a = serializer(_bulkMarkAsFulfilledRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkMarkAsFulfilledResponse, {
        _activity: _activity,
        _bulkOrderResult: _bulkOrderResult,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __bulkMarkAsFulfilled(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.BulkMarkAsFulfilled',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/bulk/orders/mark-as-fulfilled',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkMarkAsFulfilled.fromReq = fromReq;
    return __bulkMarkAsFulfilled;
}
/** Marks multiple orders as fulfilled, selected by filter. `order.fulfillmentStatus` field changes to `FULFILLED`. */
export function bulkMarkAsFulfilledByFilter(payload) {
    var _a = serializer(_bulkMarkAsFulfilledByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkMarkAsFulfilledByFilterResponse, {
        _activity: _activity,
        _bulkOrderResult: _bulkOrderResult,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __bulkMarkAsFulfilledByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.BulkMarkAsFulfilledByFilter',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/bulk/orders/mark-as-fulfilled-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkMarkAsFulfilledByFilter.fromReq = fromReq;
    return __bulkMarkAsFulfilledByFilter;
}
/** Marks an order as not fulfilled. `order.fulfillmentStatus` field changes to `NOT_FULFILLED`. */
export function markAsUnfulfilled(payload) {
    var _a = serializer(_markAsUnfulfilledRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markAsUnfulfilledResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __markAsUnfulfilled(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.MarkAsUnfulfilled',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/mark-as-unfulfilled',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markAsUnfulfilled.fromReq = fromReq;
    return __markAsUnfulfilled;
}
/** Marks multiple orders as not fulfilled. `order.fulfillmentStatus` field changes to `NOT_FULFILLED`. */
export function bulkMarkAsUnfulfilled(payload) {
    var _a = serializer(_bulkMarkAsUnfulfilledRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkMarkAsUnfulfilledResponse, {
        _activity: _activity,
        _bulkOrderResult: _bulkOrderResult,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __bulkMarkAsUnfulfilled(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.BulkMarkAsUnfulfilled',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/bulk/orders/mark-as-unfulfilled',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkMarkAsUnfulfilled.fromReq = fromReq;
    return __bulkMarkAsUnfulfilled;
}
/** Marks multiple orders as not fulfilled, selected by filter. `order.fulfillmentStatus` field changes to `NOT_FULFILLED`. */
export function bulkMarkAsUnfulfilledByFilter(payload) {
    var _a = serializer(_bulkMarkAsUnfulfilledByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkMarkAsUnfulfilledByFilterResponse, {
        _activity: _activity,
        _bulkOrderResult: _bulkOrderResult,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __bulkMarkAsUnfulfilledByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.BulkMarkAsUnfulfilledByFilter',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/bulk/orders/mark-as-unfulfilled-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkMarkAsUnfulfilledByFilter.fromReq = fromReq;
    return __bulkMarkAsUnfulfilledByFilter;
}
/**
 * Marks the order as paid. `order.paymentStatus` field *eventually* changes to `PAID`.
 * In case the order already has an offline payment transaction associated with it (usually when manual payment method is chosen at checkout) - This transaction will become approved.
 * In case the order has no payment transactions associated with it (usually when the item is set to be paid offline after checkout or when an order is created from the backoffice) - A payment transaction will be created and approved.
 */
export function markOrderAsPaid(payload) {
    var _a = serializer(_markOrderAsPaidRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markOrderAsPaidResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __markOrderAsPaid(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.MarkOrderAsPaid',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/mark-as-paid',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markOrderAsPaid.fromReq = fromReq;
    return __markOrderAsPaid;
}
/** Marks multiple orders as paid. `order.paymentStatus` field *eventually* changes to `PAID`. */
export function bulkMarkOrdersAsPaid(payload) {
    var _a = serializer(_bulkMarkOrdersAsPaidRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkMarkOrdersAsPaidResponse, {
        _activity: _activity,
        _bulkOrderResult: _bulkOrderResult,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __bulkMarkOrdersAsPaid(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.BulkMarkOrdersAsPaid',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/bulk/orders/mark-as-paid',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkMarkOrdersAsPaid.fromReq = fromReq;
    return __bulkMarkOrdersAsPaid;
}
/**
 * Call this endpoint to create an order in the payment gateway system. The amount of the order would be either:
 * 1. An explicit amount provided in the request, or;
 * 2. If an explicit amount is not provided - the remaining amount to complete the payment of that eCom order.
 * As a result, an ID of the created payment gateway order would be returned.
 * You can then use Wix Payments APIs to approve that order or collect payment, which will eventually change the eCom order state (e.g mark it as paid).
 */
export function createPaymentGatewayOrder(payload) {
    var _a = serializer(_createPaymentGatewayOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createPaymentGatewayOrderResponse, {}).fromJSON;
    function __createPaymentGatewayOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.CreatePaymentGatewayOrder',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{ecomOrderId}/create-payment-gateway-order',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createPaymentGatewayOrder.fromReq = fromReq;
    return __createPaymentGatewayOrder;
}
/** returns shipping label ids - temporarily until fully modeled in fulfillments service */
export function getShipments(payload) {
    var _a = serializer(_getShipmentsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getShipmentsResponse, {}).fromJSON;
    function __getShipments(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.GetShipments',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/shipments',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getShipments.fromReq = fromReq;
    return __getShipments;
}
export function aggregateOrders(payload) {
    var _a = serializer(_aggregateOrdersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_aggregateOrdersResponse, {}).fromJSON;
    function __aggregateOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.AggregateOrders',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/aggregate',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __aggregateOrders.fromReq = fromReq;
    return __aggregateOrders;
}
/** Restock items on order - temporary solution for POS */
export function decrementItemsQuantity(payload) {
    var _a = serializer(_decrementItemsQuantityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_decrementItemsQuantityResponse, {
        _activity: _activity,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _digitalFile: _digitalFile,
        _image: _image,
        _order: _order,
        _orderLineItem: _orderLineItem,
        _physicalProperties: _physicalProperties,
        _shippingInformation: _shippingInformation,
    }).fromJSON;
    function __decrementItemsQuantity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order',
            method: 'POST',
            methodFqn: 'com.wix.ecom.orders.v1.Orders.DecrementItemsQuantity',
            url: resolveComWixEcomOrdersV1OrdersUrl({
                protoPath: '/v1/orders/{id}/restock',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __decrementItemsQuantity.fromReq = fromReq;
    return __decrementItemsQuantity;
}
//# sourceMappingURL=http.impl.js.map